<template>
    <div class="services-budget view">
        <transition name="v-transition-result">
            <nks-result v-if="showResult" v-cloak></nks-result>
        </transition>

        <transition name="v-transition-budget">
            <div class="services-budget__inner container" v-show="!showResult">
                <div class="tabs">
                    <button class="tab is-active" @click="changeForm('budget-calculation', $event)">Calculer mon budget</button>
                    <button class="tab" @click="changeForm('budget-check', $event)">Verifier mon budget estimé</button>
                </div>
                <transition name="v-transition-budget-form" mode="out-in">
                    <component :is="currentForm"></component>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    import Result from './Result.vue';
    import { eventBus } from '../../main';
    import BudgetCalculation from './BudgetCalculation.vue';
    import BudgetCheck from './BudgetCheck.vue';

    export default {
        components: {
            "nks-result": Result,
            "budget-calculation": BudgetCalculation,
            "budget-check": BudgetCheck,
        },
        data(){
            return {
                selectedAction: 'none',
                currentForm: 'budget-calculation',
            }
        },
        computed: {
            showResult() {
                return this.$store.state.budget.showResult;
            }
        },
        methods: {
            changeForm(form, evt) {
                this.currentForm = form;
                $(evt.target).addClass('is-active').siblings().removeClass('is-active');
            },
            onKeyboardHide() {
                $('body').removeClass('keyboardOpened');
            },
            onKeyboardShow() {
                $('body').addClass('keyboardOpened');
            }
        },
        created() {
            //ajout des evenements pour le clavier via le plugin ionic-plugins-keyboard
            if(this.$store.state.isApp) {
                window.addEventListener('native.keyboardshow', this.onKeyboardShow);
                window.addEventListener('native.keyboardhide', this.onKeyboardHide);
            }



        },
        destroyed() {
            if(this.$store.state.isApp) {
                window.removeEventListener('native.keyboardshow', this.onKeyboardShow);
                window.removeEventListener('native.keyboardhide', this.onKeyboardHide);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Budget.vue?a405a456